export default __webpack_public_path__ + "static/media/pvilla3-2.1ddd8706.jpg";